



import { Component, Vue } from "vue-property-decorator";
import { logout } from "@/req/user";
@Component
export default class Logout extends Vue {
  public beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await logout({ token: window.App.$fn.cookies.getToken() });
      window.App.$fn.cookies.removeToken();
      sessionStorage.removeItem("path");
      window.top.location.href = "/#/login";
    });
  }
}
